<template>
  <BaseTableWrapper no-body>
    <template #top-buttons>
      <div class="float-right mb-1" v-if="$route.name === 'EXABOrganizationLeadList' && ableToAddOrganizationLead">
        <router-link tag="button" :to="{ name: 'EXABOrganizationLeadCreate' }" class="btn btn-sm btn-primary">{{ $t('buttons.create') }}</router-link>
      </div>
    </template>
    <template #filtering>
      <div class="text-right">
        <b-button v-if="filterStatus" variant="danger" class="btn-sm" v-b-tooltip.hover :title="$t('buttons.clearFilters')" @click="clearFilters"><i class="fa fa-sync"></i><span>{{$t('global.filtersAreSet')}}</span></b-button>
        <b-button aria-controls="organizationlead_search_collapse" class="btn-sm ml-2" v-b-tooltip.hover :title="$t('buttons.search')"  v-b-toggle.organizationlead_search_collapse variant="primary"><i class="fa fa-filter"></i></b-button>
      </div>
      <div>
        <b-collapse id="organizationlead_search_collapse" class="mt-2">
          <EXABOrganizationLeadFiltering :idUserData="idUserData" @getPage="getPage($event)" ref="organizationLeadFiltering"/>
        </b-collapse>
      </div>
    </template>
    <template #body>
      <b-row>
        <b-col>
          <template v-if="isLoading">
            <Loader></Loader>
          </template>
          <template v-else>
            <div v-if="items.length > 0">
              <table class="table table-striped table-hover">
                <thead>
                <tr>
                  <th>{{$t('views.exaborganizationlead.form.idStatus')}}</th>
                  <th>{{$t('views.exaborganizationlead.form.idUserData')}}</th>
                  <th>{{$t('views.exaborganizationlead.form.title')}}</th>
                  <th>{{$t('views.excmmessages.list.createdAt')}}</th>
                  <th>{{$t('views.exsborder.list.tags')}}</th>
                  <th></th>
                </tr>
                </thead>
                <tr  v-for="item in items"
                     :key="item['@id']">
                  <td>
                    <span v-if="item.idSalesOpportunity" v-b-tooltip.hover :title="$t('views.firm.form.idOpportunity') + ': ' + item.idSalesOpportunity.title" :style="'color: ' + item.idSalesOpportunity.color" class="h6 mt-0 mb-0"><i class="fa fa-circle fa-lg mr-2"></i></span>
                    <span v-if="item.idStatus" v-b-tooltip.hover :title="$t('views.firm.form.idStatus') + ': ' + item.idStatus.title" :style="'color: ' + item.idStatus.color" class="h6 mt-0 mb-0"><i class="fa fa-circle fa-lg mr-2"></i></span>
                  </td>
                  <td>
                    <router-link v-if="item.idUserData && item.idUserData.isCompany === 0" :to="{name: 'UserDataShow', params: { id: item.idUserData['@id'] }}">
                      {{ item.idUserData.name }} {{ item.idUserData.surname }}
                    </router-link>
                    <router-link v-else-if="item.idUserData" :to="{name: 'FirmShow', params: { id: item.idUserData['@id'] }}">
                      {{ item.idUserData.firmname1 === '' ? item.idUserData.fullName : item.idUserData.firmname1 }}
                    </router-link>
                  </td>
                  <td>
                    <router-link :to="{name: 'EXABOrganizationLeadShow', params: { id: item['@id'] }}">
                      <span>{{item.title}}</span>
                    </router-link>
                  </td>
                  <td>
                    {{ $moment(item.createdAt).format('YYYY-MM-DD HH:mm') }}
                  </td>
                  <td>
                    <span v-for="tag in item.tags" :key="tag['@id']">
                      <b-badge class="mr-2 mb-2 organizationleadtag" pill :style="{'background-color': tag.tag.color}"><i class="fa fa-tags mr-2"></i>{{tag.tag.tag}}</b-badge>
                    </span>
                  </td>
                  <td>
                    <b-dropdown variant="link" size="sm" right text="Right align">
                      <template #button-content>
                        <i class="fa fa-bars fa-lg"></i>
                      </template>
                      <b-dropdown-item @click="show(item['@id'])"><i class="fa fa-eye mr-2"></i>{{$t('buttons.show')}}</b-dropdown-item>
                      <b-dropdown-item @click="edit(item['@id'])"><i class="fa fa-edit mr-2"></i>{{$t('buttons.edit')}}</b-dropdown-item>
                      <b-dropdown-item @click="addNoteToOrganizationLeadModal(item['@id'])"><i class="fa fa-sticky-note mr-2"></i> {{$t('buttons.addNote')}}</b-dropdown-item>
                      <b-dropdown-item @click="addPhoneToOrganizationLeadModal(item['@id'])"><i class="fa fa-phone mr-2"></i> {{$t('buttons.addPhoneNote')}}</b-dropdown-item>
                      <b-dropdown-item @click="addMeetingToOrganizationLeadModal(item['@id'])"><i class="fa fa-calendar mr-2"></i> {{$t('buttons.addRelationNote')}}</b-dropdown-item>
                      <b-dropdown-item v-if="item.state === 1 " @click="archiveItem(item['@id'])"><i class="fa fa-edit mr-2"></i>{{$t('buttons.archive')}}</b-dropdown-item>
                      <b-dropdown-item v-if="item.state === 0 " @click="unArchiveItem(item['@id'])"><i class="fa fa-edit mr-2"></i>{{$t('buttons.unArchive')}}</b-dropdown-item>
                      <b-dropdown-item @click="deleteSingle(item['@id'])"><i class="fa fa-trash mr-2"></i> {{$t('buttons.delete')}}</b-dropdown-item>
                    </b-dropdown>
                  </td>
                </tr>
              </table>
            </div>
            <div v-else>
              {{$t('notifications.noData')}}
            </div>
            <b-row v-if="$route.name !== 'EXABOrganizationLeadCreate' && idUserData">
              <b-col>
                <b-btn size="sm" v-if="ableToAddOrganizationLead" class="btn btn-success" @click="addNewOrganizationLead()">{{ $t('views.exaborganizationlead.form.addNewLead') }}</b-btn>
              </b-col>
            </b-row>
            <div v-if="view">
              <pagination
                :totalItems="totalItems"
                :view="view"
                @getPage="getPage($event)"
                @getPageNumber="setCurrentPage($event.page)"
              ></pagination>
            </div>
            <div class="float-right">
              <b-button v-if="downloadXlsStatus === 0" variant="info" @click="downloadXLS()" v-b-tooltip.hover :title="$t('buttons.downloadXLS')" class="float-left ml-2 mr-2 btn-circle">
                <i class="fal fa-file-spreadsheet"></i>
              </b-button>
              <b-button v-if="downloadXlsStatus === 1" variant="success" v-b-tooltip.hover :title="$t('buttons.downloadXLS')" class="float-left ml-2 mr-2 btn-circle">
                <i class="fal fa-spinner fa-spin"></i>
              </b-button>
            </div>
          </template>
        </b-col>
      </b-row>
      <OrganizationLeadCreateModal v-if="idUserData" :id-user-data="idUserData" @organizationLeadCreated="getPage(view['@id'])"></OrganizationLeadCreateModal>
    </template>
  </BaseTableWrapper>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import BaseTableWrapper from '@/components/BaseComponents/BaseTableWrapper'
import Loader from '../../../Layout/Loader'
import Pagination from '../../../Layout/Pagination'
import remove from '@/utils/remove'
import EXABOrganizationLeadFiltering from '@/components/Dashboard/Views/AgreementsBundle/exaborganizationlead/components/OrganizationLeadFiltering.vue'
import addParamsToQuery from '@/utils/addParamsToQuery'
import { archive, unArchive } from '@/utils/archive'
import { checkPermission } from '@/utils/checkRoles'
import OrganizationLeadCreateModal from '@/components/Dashboard/Views/AgreementsBundle/exaborganizationlead/modals/OrganizationLeadCreateModal.vue'
import ApiService from '@/utils/ApiService'

export default {
  name: 'OrganizationLeadList',
  components: {
    OrganizationLeadCreateModal,
    EXABOrganizationLeadFiltering,
    Loader,
    Pagination,
    BaseTableWrapper
  },
  props: {
    idUserData: {
      type: String,
      default: null
    },
    addNoteToOrganizationLeadModal: {
      type: Function,
      required: false,
      default: () => {}
    },
    addPhoneToOrganizationLeadModal: {
      type: Function,
      required: false,
      default: () => {}
    },
    addMeetingToOrganizationLeadModal: {
      type: Function,
      required: false,
      default: () => {}
    }
  },
  data () {
    return {
      downloadXlsStatus: 0
    }
  },
  computed: {
    ...mapGetters({
      deletedItem: 'exaborganizationlead/del/deleted',
      error: 'exaborganizationlead/list/error',
      items: 'exaborganizationlead/list/items',
      isLoading: 'exaborganizationlead/list/isLoading',
      view: 'exaborganizationlead/list/view',
      totalItems: 'exaborganizationlead/list/totalItems'
    }),
    filterStatus () {
      return JSON.stringify(this.$store.state.filters.organizationLeadsFilter) !== JSON.stringify(this.$store.state.filters.organizationLeadsFilterReference)
    },
    searchParams () {
      if (this.idUserData) {
        return {
          idUserData: this.idUserData,
          state: 1,
          itemsPerPage: 10
        }
      }
      return this.$store.state.filters.organizationLeadsFilter
    },
    ableToAddOrganizationLead () {
      return checkPermission('firms', 'EXABOrganizationLeadCreate')
    }
  },
  beforeCreate () {
    if (Object.keys(this.$store.state.filters.organizationLeadsFilter).length === 0) {
      this.$store.state.filters.organizationLeadsFilter = JSON.parse(JSON.stringify(this.$store.state.filters.organizationLeadsFilterReference))
    }
  },
  created () {
    let params = Object.assign({}, this.searchParams)
    if (!this.idUserData) {
      params['_page'] = this.$store.state.filters.organizationLeadsFilterCurrentPage
    }
    let url = addParamsToQuery('e_x_a_b_organization_leads', params)
    this.getPage(url)
  },
  methods: {
    clearFilters () {
      if (this.$refs.organizationLeadFiltering) {
        this.$refs.organizationLeadFiltering.clearFilters()
      }
    },
    ...mapActions({
      getPage: 'exaborganizationlead/list/default'
    }),
    setCurrentPage (page) {
      if (this.idUserData) {
        return
      }
      this.$store.state.filters.organizationLeadsFilterCurrentPage = page
    },
    show (id) {
      this.$router.push({ name: 'EXABOrganizationLeadShow', params: { id: id } })
    },
    edit (id) {
      this.$router.push({ name: 'EXABOrganizationLeadUpdate', params: { id: id } })
    },
    addNewOrganizationLead () {
      this.toggleAddOrganizationLeadModal()
    },
    archiveItem (id) {
      archive(id, () => { this.getPage(this.view['@id']) })
    },
    unArchiveItem (id) {
      unArchive(id, () => { this.getPage(this.view['@id']) })
    },
    deleteSingle (id) {
      remove(id, () => {
        this.getPage(this.view['@id'])
      })
    },
    async downloadXLS () {
      this.downloadXlsStatus = 1
      await new ApiService('e_x_a_b_organization_leads/download_xls', this.searchParams).downloadFile('organization_leads.xls')
      this.downloadXlsStatus = 0
    },
    ...mapMutations({
      toggleAddOrganizationLeadModal: 'exaborganizationlead/createModal/toggleModal'
    })
  }
}
</script>
